module.exports = __webpack_public_path__ + "img/benzhub1.07ee87ef.png";